<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Fotos</h4>
          </div>

          <select v-model="category" @change="changeCategory()" class="form-control" style="max-width: 400px;">
            <option value="null">Todas as categorias</option>
            <option v-for="category of categories" :value="category.category">{{ category.category }}</option>
          </select>

          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%">Foto</th>
                <th style="width: 20%">Categoria</th> 
                <th>Keywords</th> 
              </tr>
            </thead>
            <tbody>
              <tr v-for="picture of suggestions">
                <td>
                  <img :src="picture.url" width="60">
                </td>
                <td>{{ picture.category }}</td>
                <td>
                  <input @blur="save(picture)" type="text" class="form-control bg-white" v-bind:class="{ 'has-error': picture.error, success: picture.success }" style="border-radius: 0; border-color: #888;" v-model="picture.keywords">
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                v-model="current_page"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Card,
  } from 'src/components'
import SuggestionsPicturesService from '@/services/SuggestionsPicturesService.js'

export default {
    components: {
      Card,
    },
    data() {
      return {
        suggestions: [],
        categories: [],
        category: 'null',
        total: 0,

        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadSuggestions()
      },
      loadSuggestions() {
        SuggestionsPicturesService.load(`?page=${this.current_page}&per_page=10&category=${this.category}`).then(res => {
          this.pageCount = res.data.lastPage
          this.suggestions = res.data.data
          this.total = res.data.total; 
        }).catch(err => {
          console.error(err)
        })
      },
      loadSuggestionsCategories() {
        SuggestionsPicturesService.getCategories().then(res => {
          this.categories = res.data
        }).catch(err => {
          console.error(err)
        })
      },
      save(picture) {
        SuggestionsPicturesService.save(picture).then(res => {
          picture.success = true;
          this.$forceUpdate()

          setTimeout(() => {
            picture.success = false;
            this.$forceUpdate()
          }, 2000)

        }).catch(err => {
          picture.error = true
          this.$forceUpdate()

          setTimeout(() => {
            picture.error = false;
            this.$forceUpdate()
          }, 2000)
        })
        picture.focused = false;
      },
      changeCategory() {
        this.current_page = 1
        this.loadSuggestions()
        this.$forceUpdate()
      }
    },
    mounted() {
      this.loadSuggestions()
      this.loadSuggestionsCategories()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .has-error{ 
    background-color: #ffcccb !important;
  }
  .success{ 
    background-color: #d0ffd2 !important;
  }
</style>